import { render, staticRenderFns } from "./BasePridssIcon.vue?vue&type=template&id=1db6837d&scoped=true"
import script from "./BasePridssIcon.vue?vue&type=script&lang=js"
export * from "./BasePridssIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db6837d",
  null
  
)

export default component.exports